import React, { Component } from "react";
import "./referent.css";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import { Button } from "react-bootstrap";
import "@brainhubeu/react-carousel/lib/style.css";
import Carousel, { Dots } from "@brainhubeu/react-carousel";

class referent extends Component {
  constructor(props) {
    super(props);
    this.state = { waiter: { tabServeur: [] }, referent: [], nom: "" };
  }
  // Query ?restoID=... : cible l'établissement choisi (onglet par
  // établissement) côté backend. Vide = comportement historique. TPB-60
  referentQuery = () => {
    const restoID = new URLSearchParams(window.location.search).get("restoID");
    return restoID ? "?restoID=" + encodeURIComponent(restoID) : "";
  };
  change = (event) => {
    let referent = this.state.referent;
    referent[event.target.name] = event.target.value;
    this.setState({
      referent: referent,
      // identifier name de l'input = choisir la valeur qui se trouve dans l'input donc necessité d'avoir le bon name!!
    });
  };
  getReferentWallet = () => {
    const headers = new Headers({
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
    });

    const options = {
      method: "GET",
      headers: headers,
    };

    fetch(
      process.env.REACT_APP_BACKEND_URL +
        "/serveur/referentWallet" +
        this.referentQuery(),
      options
    )
      .then((response) => {
        return response.json();
      })
      .then(
        (responseObject) => {
          const amount = responseObject;
          this.setState({ amount: amount });
        },

        (error) => {
        }
      );
  };
  getWaiterList = () => {
    const headers = new Headers({
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
    });

    const options = {
      method: "GET",
      headers: headers,
    };

    fetch(
      process.env.REACT_APP_BACKEND_URL +
        "/serveur/waiterList" +
        this.referentQuery(),
      options
    )
      .then((response) => {
        return response.json();
      })
      .then(
        (responseObject) => {
          this.setState({ waiter: responseObject });
        },

        (error) => {
        }
      );
  };

  componentShouldUpdate() {
    this.getWaiterList();
  }

  renderMesServeurs = () => {
    // Garde : si le serveur n'est pas (ou plus) référent, le backend ne renvoie
    // pas de tabServeur -> on évite le crash (page blanche) et on informe. TPB-60
    const tab =
      (this.state.waiter && this.state.waiter.tabServeur) || [];
    if (!tab.length) {
      return (
        <Col xs={12} s={12} md={12}>
          <p style={{ textAlign: "center" }}>
            Vous n'êtes pas (ou plus) référent d'un établissement.
          </p>
        </Col>
      );
    }
    return tab.map((element) => {
      return (
        <Col className="nameServ" xs={12} s={12} md={6}>
          <h3>
            <strong>
              {element.serveurName}
              {""}
              {element.serveurLastName}
            </strong>
          </h3>
          <br />
          <Form>
            <Form.Control
              type="number"
              placeholder="Montant du transfert"
              name="amount"
              onChange={this.change}
            />
          </Form>
          <Button
            className="CollectButton"
            type="submit"
            onClick={() => {
              const headers = new Headers({
                "Content-Type": "application/json",
                Authorization: "bearer " + localStorage.getItem("token"),
              });
              const data = {
                email: element.serveurMail,
                amount: this.state.referent.amount,
                // Débite le pot de l'établissement courant (onglet). TPB-60
                restoID:
                  new URLSearchParams(window.location.search).get("restoID") ||
                  undefined,
              };
              const options = {
                method: "POST",
                headers: headers,
                body: JSON.stringify(data),
              };

              fetch(
                process.env.REACT_APP_BACKEND_URL + "/serveur/referentTransfert",
                options
              )
                .then((response) => {
                  return response.json();
                })
                .then(
                  (data) => {
                    this.setState({ message: data.message });
                    this.getReferentWallet();
                  },

                  (error) => {
                  }
                );
            }}
          >
            Envoyer
          </Button>
        </Col>
      );
    });
  };

  componentDidMount() {
    const nom = new URLSearchParams(window.location.search).get("nom");
    if (nom) {
      this.setState({ nom });
    }
    this.getReferentWallet();
    this.getWaiterList();
  }

  render() {
    return (
      <Container className="mesHisto">
        <Row className="rowRetourProfil">
          <Col xs={12} s={12} md={12}>
            <Button className="retourProfilButton" href="/monProfil">
              Retour sur votre profil
            </Button>
          </Col>
        </Row>
        <Row className="commentaireHisto">
          <Col xs={12} s={12} md={12}>
            {this.state.nom ? (
              <h1 style={{ marginBottom: "10px" }}>
                Compte référent - {this.state.nom}
              </h1>
            ) : null}
            <h1>Montant du pot commun :</h1>
            <h2 className="montantCo">
              <strong>
                {this.state.amount ? this.state.amount / 100 : 0} euros
              </strong>
            </h2>
            <p>
              Les frais de gestion seront automatiquement prélevés de la part
              distribuée à chaque bénéficiaire.
            </p>
            <h1>Liste des bénéficiaires:</h1>
          </Col>
        </Row>

        <Row className="rowServeurCo">{this.renderMesServeurs()}</Row>
        <p style={{ textAlign: "center" }}>{this.state.message}</p>
      </Container>
    );
  }
}

export default referent;
